import type { DriveItem } from "../../hooks/drive/driveTypes";
import { getDisplayFileName } from "../../utils/driveFolder";
import { nameMatches } from "./nameMatches";

/** How many files instant search lists. */
const FILE_RESULTS = 5;

/** Drive files whose name matches what's being typed, for instant search: newest first, each name once. */
export function searchFiles(text: string, files: DriveItem[]): { name: string; file: DriveItem }[] {
  const found = new Map<string, DriveItem>();
  files.forEach((file) => {
    const name = getDisplayFileName(file.attachment.name);
    if (!found.has(name) && nameMatches(name, text)) found.set(name, file);
  });
  return Array.from(found, ([name, file]) => ({ name, file })).slice(0, FILE_RESULTS);
}
